<template>
  <v-list-tile>
    <v-dialog v-model="mostrarDialogoDespublicar" persistent :max-width="Modal.Processamento.larguraMaxima">
      <v-list-tile-title slot="activator" @click="$emit('acao-ativada')">
        <i class="fas fa-ban mr-2" aria-hidden="true"/>
        Despublicar
      </v-list-tile-title>

      <v-card :min-width="Modal.Processamento.larguraMinima" :max-width="Modal.Processamento.larguraMaxima">
        <v-card-title class="primary modal-title" primary-title>
          <span style="font-weight: bold">Despublicar Credenciamento</span>
          <v-btn flat depressed @click="fecharModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="az-form-content pa-4">
          <v-textarea
              name="motivo"
              v-model="motivo"
              rows="3"
              placeholder="Digite aqui o motivo"
              maxlength="255"
              :error-messages="errors.collect('motivo')"
              v-validate="'required'"
              :counter="255"
          >
            <template v-slot:label>
              Motivo <span class="campo-obrigatorio">*</span>
            </template>
          </v-textarea>

        </v-card-text>

        <v-divider />

        <v-card-actions class="px-3 py-2">
          <v-btn color="#9F9F9F" style="border-radius: 5px" outline flat @click="fecharModal">
            Cancelar
          </v-btn>
          <v-spacer />
          <v-btn color="primary" style="border-radius: 5px" depressed @click="confirmarDespublicacao()">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>

import {Modal} from "@/commons/constants/utilitarios";
import {actionTypes} from "@/commons/constants";
import {mapActions, mapState} from "vuex";

export default {
  name: 'CredenciamentoAcoesDespublicar',
  computed: {
    Modal() {
      return Modal
    },
    ...mapState(['licitacao', 'loki'])
  },
  props: {
    credenciamentoId: {
      required: true
    }
  },
  data() {
    return {
      globalLoadingAtivado: false,
      mostrarDialogoDespublicar: false,
      motivo: '',
    }
  },
  methods: {
    async confirmarDespublicacao() {
      const validado = await this.$validator.validate('motivo')
      if (!validado) {
        this.mostrarNotificacaoErro('É necessário informar um motivo para realizar a operação.')
        return
      }

      await this.despublicar()
    },
    async redirecionarAposDespublicacao() {
      const destino = {
        name: 'CredenciamentoAtualizacaoDadosGerais',
        params: {id: this.credenciamentoId},
        query: {edicao: true}
      }
      const rotaAtual = this.$route
      const mesmaRota = rotaAtual.name === destino.name && String(rotaAtual.params.id) === String(destino.params.id) && String(destino.query.edicao) === String(rotaAtual.query.edicao)
      if (!mesmaRota) {
        await this.$router.push(destino)
        await new Promise(resolve => setTimeout(resolve, 1500))
        await this.buscarLicitacao(this.credenciamentoId)
      } else {
        await new Promise(resolve => setTimeout(resolve, 1500))
        await this.buscarLicitacao(this.credenciamentoId)
      }
    },
    habilitarLoading() {
      this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
      this.habilitarLoadingGlobal()
    },
    desabilitarLoading() {
      if (!this.globalLoadingAtivado) {
        this.desabilitarLoadingGlobal()
      }
    },
    async despublicar() {
      this.habilitarLoading()
      this.setMensagemLoading('Despublicando...')
      try {
        const payload = {
          credenciamentoId: this.credenciamentoId,
          motivo: this.motivo
        }
        const response = await this.despublicarCredenciamento(payload)

        if (response) {
          this.mostrarNotificacaoSucesso('Credenciamento despublicado com sucesso.')
          await this.redirecionarAposDespublicacao()
        }
        this.fecharModal()
        this.desabilitarLoading()
      } catch (e) {
        this.desabilitarLoading()
        const backendMessage = (e && e.response && e.response.data && (e.response.data.message || e.response.data.detail || e.response.data.mensagem))
        const mensagem = backendMessage || (e && e.message) || 'Ocorreu um erro ao despublicar.'
        this.mostrarNotificacaoErro(mensagem)
      }
    },
    fecharModal() {
      this.mostrarDialogoDespublicar = false
      this.motivo = ''
    },
    ...mapActions([actionTypes.CREDENCIAMENTO.DESPUBLICAR_CREDENCIAMENTO, actionTypes.BUSCAR_LICITACAO])
  }
}
</script>

<style scoped>
.v-dialog__container {
  width: 100%;
}

.modal-title {
  justify-content: space-between;
}

.modal-title .v-btn {
  padding: 0;
  margin: 0;
  color: #fff;
  box-sizing: border-box;
  min-width: 25px;
}

.campo-obrigatorio {
  color: red;
  margin-left: 2px;
}

</style>

